import Vue from "vue";
import VueRouter from "vue-router";
import LayoutBasic from "@/layouts/LayoutBasic";
import LayoutBasic2 from "@/layouts/LayoutBasic2";
// import { MessageBox } from 'element-ui';
// import { path } from "d3";
// import { component } from "vue/types/umd";

Vue.use(VueRouter);

const routes = [
  // 只要访问根路径就重定向到登录页面
  {
    path: "/",
    redirect: "/project",
  },
  {
    path: "/login",
    component: () => import("@/components/Login"),
  },
  {
    path: "/home",
    component: LayoutBasic2,
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: () => import("@/views/home"),
      },
      {
        path: "/project",
        component: () => import("@/views/project"),
      },

    ],
  },
  {
    path: "/manage/ontology",
    component: LayoutBasic,
    redirect: "/manage/ontology",
    children: [

      // 知识管理
      {
        // 知识建模
        path: "/manage/ontology",
        component: () => import("@/views/manage/ontology.vue"),
      },
      {
        // 知识图谱管理
        path: "/manage/instance",
        component: () => import("@/views/manage/instance.vue"),
      },
      {
        // 可视化
        path: "/manage/depth",
        component: () => import("@/views/manage"),
      },
      // {
      //   // 可视化
      //   path: "/manage/timing",
      //   component: () => import("@/views/manage/timing.vue"),
      // },

      // 知识更新
      {
        // 知识抽取
        path: "/mergeGraph/extract",
        component: () => import("@/views/mergeGraph/extract.vue"),
      },
      {
        // 知识抽取
        path: "/mergeGraph/merge",
        component: () => import("@/views/mergeGraph/merge.vue"),
      },
      {

        path: "/mergeGraph/extractManage",
        component: () => import("@/views/mergeGraph/extractManage.vue"),
      },
      // {
      //   //实体标注
      //   path: "/mergeGraph/mark",
      //   component: () => import("@/views/mergeGraph/mark.vue"),
      // },
      {
        path: '/kgBase/index',
        name: 'kgBase',
        component: () => import('@/views/kgBase/index.vue')
      },
      {
        path: '/kgBase/cardList',
        name: 'CardList',
        component: () => import('@/views/kgBase/cardList.vue')
      },
      {
        path: "/manage/showTimeRel",
        component: () => import("@/views/manage/showTimeRel.vue")
      },
      {
        path: "/manage/showGraph",
        component: () => import("@/views/manage/showGraph.vue")
      },
      // 知识应用
      // {
      //   // 图谱问答
      //   path: "/apply/answer",
      //   component: () => import("@/views/answer"),
      // },
      // {
      //   // 场景自动生成引擎
      //   path: "/apply/engine",
      //   component: () => import("@/views/apply/engine.vue"),
      // },
    ],
  },
  {
    path: "/knowledgeConstruction/ontologyModeling",
    component: LayoutBasic,
    redirect: "/knowledgeConstruction/ontologyModeling",
    children: [
      //知识本体建模-整合
      {
        path: "/knowledgeConstruction/ontologyModeling",
        component: () => import("@/views/knowledgeConstruction/ontologyModeling.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
      //知识实体管理-整合
      {
        path: "/knowledgeConstruction/instanceManagement",
        component: () => import("@/views/knowledgeConstruction/instanceManagement.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
    ]
  },
  {
    path: "/knowledgeExtract/extractManagement",
    component: LayoutBasic,
    redirect: "/knowledgeExtract/extractManagement",
    children: [
      //知识抽取管理-整合
      {
        path: "/knowledgeExtract/extractManagement",
        component: () => import("@/views/knowledgeExtract/extractManagement.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
      //知识抽取-整合
      {
        path: "/knowledgeExtract/extract",
        component: () => import("@/views/knowledgeExtract/extract.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
    ]
  },
  //知识融合-整合
  {
    path: "/knowledgeFusion",
    component: () => import("@/views/knowledgeFusion.vue"),
    meta: {
      showHeader: false,
      showAside: false,
    },
  },
  {
    path: "/knowledgeReasoningn/depth",
    component: LayoutBasic,
    redirect: "/knowledgeReasoningn/depth",
    children: [
      //知识推理-整合
      {
        path: "/knowledgeReasoningn/depth",
        component: () => import("@/views/knowledgeReasoningn"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
      {
        path: "/knowledgeReasoningn/time",
        component: () => import("@/views/knowledgeReasoningn/time.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
      {
        path: "/knowledgeReasoningn/graph",
        component: () => import("@/views/knowledgeReasoningn/graph.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
    ]
  },
  {
    path: "/fileManagement",
    component: LayoutBasic,
    redirect: "/fileManagement",
    children: [
      //文件管理-整合
      {
        path: "/fileManagement",
        component: () => import("@/views/fileManagement/index.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
      {
        path: "/fileManagement/cardList",
        component: () => import("@/views/fileManagement/cardList.vue"),
        meta: {
          showHeader: false,
          showAside: false,
        },
      },
    ]
  },





];
// const whiteList = [
//   '/mergeGraph/newExtract',

// ];
const router = new VueRouter({
  routes,
});
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // 1. 尝试从 URL 查询参数中获取 token 和 userId（跨域跳转接力场景）
  const urlToken = to.query.token;
  const urlUserId = to.query.userId;

  if (urlToken) {
    // 2. 如果 URL 携带了 token，立即存入当前系统的 sessionStorage
    window.sessionStorage.setItem("token", urlToken);
    if (urlUserId) {
      window.sessionStorage.setItem("userId", urlUserId);
    }

    // 3. 【关键点】构造一个新的 query 对象，剔除 token 和 userId
    // 这样做的目的是防止用户复制分享带有 token 的 URL，导致安全问题
    const newQuery = { ...to.query };
    delete newQuery.token;
    delete newQuery.userId;

    // 4. 使用 replace 模式重新跳转当前路由（静默抹除地址栏上的参数）
    next({
      path: to.path,
      query: newQuery,
      replace: true // 替换当前历史记录，防止用户点击浏览器“后退”又出现带 token 的 URL
    });
    return; // 结束当前守卫，等待重定向的新导航触发
  }

  // 5. 常规逻辑：如果 URL 没有 token，检查本地存储
  const token = window.sessionStorage.getItem("token");
  console.log("当前使用的token", token);
  
  if (!token && to.path !== "/login") {
    // 如果没有 token，且不是访问登录页，跳转到登录页
    next("/login");
  } else {
    // 有 token 或是去登录页，正常放行
    next();
  }
});


// token失效后给出提示并自动退出登录
// let intervalId; 
// router.beforeEach((to, from, next) => {
//   clearInterval(intervalId);
//   intervalId = setInterval(() => {
//     const tokenStr = window.sessionStorage.getItem('token');
//     if (!tokenStr && to.path !== '/login') {
//       clearInterval(intervalId); 
//       MessageBox.confirm('登录已过期，请重新登录。点击确认跳转到登录页面。', '提示', {
//         confirmButtonText: '确认',
//         type: 'warning',
//         showCancelButton: false 
//       }).then(() => {
//         next('/login'); 
//       });
//     }
//   }, 1000);
//   next();
// });


export default router;
